import "react-quill/dist/quill.snow.css";

import { forwardRef, useMemo } from "react";

import ReactQuill from "react-quill";
import { cn } from "@/utils/misc";

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  readOnly?: boolean;
}

export const RichTextEditor = forwardRef<ReactQuill, RichTextEditorProps>(
  ({ value, onChange, placeholder, className, readOnly = false }, ref) => {
    const modules = useMemo(
      () => ({
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }],
          ["link"],
          ["clean"],
        ],
      }),
      [],
    );

    const formats = [
      "header",
      "bold",
      "italic",
      "underline",
      "list",
      "bullet",
      "indent",
      "link",
    ];

    return (
      <div className={cn("rich-text-editor", className)}>
        <ReactQuill
          ref={ref}
          theme="snow"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          modules={modules}
          formats={formats}
          readOnly={readOnly}
          style={{
            backgroundColor: "transparent",
          }}
        />
      </div>
    );
  },
);

RichTextEditor.displayName = "RichTextEditor";

// Component for displaying rich text content
interface RichTextDisplayProps {
  content: string;
  className?: string;
}

export const RichTextDisplay = ({
  content,
  className,
}: RichTextDisplayProps) => {
  if (!content) return null;

  return (
    <div
      className={cn("rich-text-display prose prose-sm max-w-none", className)}
      dangerouslySetInnerHTML={{ __html: content }}
      style={{
        // Ensure proper styling for rich text content
        wordBreak: "break-word",
      }}
    />
  );
};
